import { SetupCall } from '@driscollsinc/driscolls-display-rules';
import { LOOKUP_FIELDS } from '../constants';
import { lookupSetupFields } from './CommonSetupFields';

function configureSetupCall() {
    SetupCall(
        LOOKUP_FIELDS.CustomerCodeCategoryLookUp,
        [...lookupSetupFields],
        {}, //options
        (data) => {
            console.log('CustomerCodeCategoryLookUp REDUCER-- ', data);
        }
    );
}

const CustomerCodeCategoryLookUp = {
    configureSetupCall
};

export default CustomerCodeCategoryLookUp;
